// Die tv-app beim Einschalten nach vorn holen (nur Samsung Tizen).
//
// Anlass: am U800F (Tizen 9) stand nach dem Cast-Standby-Neustart beim
// Einschalten die YouTube-App des vorigen Casts auf dem Schirm statt der
// Hotel-App - die Firmware stellt die zuletzt benutzte App wieder her. Erst
// HOME holte die Start-App. Die Anmeldedaten waren zwar geloescht, aber der
// naechste Gast sieht die App seines Vorgaengers, und frueher kam so auch
// Samsung TV Plus nach vorn.
//
// Beenden laesst sich die fremde App nicht: tizen.application.kill braucht
// das Privileg appmanager.kill (Stufe platform), das ein Partner-Zertifikat
// nicht bekommt. Also holt sich die App selbst nach vorn - mit
// tizen.application.launch auf die EIGENE Id (Privileg application.launch,
// nur in der 6.5-Konfiguration; auf 4.0-6.0 scheitert der Aufruf und es
// bleibt beim bisherigen Verhalten).
//
// NUR beim Einschalten, NICHT beim Standby: waere die App im Standby
// sichtbar, verwuerfe der Cast-Standby-Neustart seine letzte Pruefung ("App
// im Vordergrund") und das Loeschen fiele aus - und das visibilitychange
// zaehlte als Aufwachen und setzte POWER_STATE auf ON, woraufhin die
// WGT-Startdatei den TV beim naechsten Laden einschaltet.
//
// Geprueft wird zweimal (CHECK_DELAYS_MS): die Firmware stellt ihre App
// womoeglich erst NACH der Power-Meldung wieder her.
//
// Und NICHT, solange Google Cast castet: ein Handy kann den TV per Cast
// einschalten, dann gehoert die Ziel-App (YouTube, Netflix) nach vorn.

const CHECK_DELAYS_MS = [1500, 5000];
let timers = [];
// Ein Cast-Standby-Neustart laeuft (siehe forReboot). Solange das gilt,
// zaehlen Sichtbarkeit und Power-Meldungen nicht als Aufwachen.
let rebootImminent = false;

// Ab welcher Tizen-Version forReboot die App vor dem Neustart nach vorn holt.
//
// Gemessen 02.10.2026: am U800F (Tizen 9) laeuft danach rebootDevice wie
// geplant. Am BU800 (Tizen 6.5) blieb das JavaScript nach dem launch im
// Standby stehen - die Zeile von rebootDevice kam nie, der TV startete nicht
// neu, der vorab geschriebene Hotspot-Schluessel wurde nicht aktiv (falsches
// Passwort) und die Anmeldedaten blieben. Ohne launch lief der Neustart dort
// zweimal fehlerfrei. 7 als Grenze, weil dazwischen nichts gemessen ist.
const REBOOT_FRONT_MIN_TIZEN = 7;

function tizenMajor() {
  try {
    const v = window.tizen.systeminfo.getCapabilities().platformVersion || '';
    const n = parseInt(String(v).split('.')[0], 10);
    return isNaN(n) ? 0 : n;
  } catch (e) {
    return 0;
  }
}

function ownAppId() {
  try {
    return window.tizen.application.getCurrentApplication().appInfo.id;
  } catch (e) {
    return null;
  }
}

// Laeuft gerade ein Cast? Wie in Cast/Tizen.js ohne finalize - das koennte den
// Cast beenden.
function isCasting() {
  try {
    const gc = window.webapis && window.webapis.googlecast;
    if (!gc || typeof gc.getStatus !== 'function') return false;
    gc.initialize();
    return gc.getStatus() === 'CASTING';
  } catch (e) {
    return false;
  }
}

function launchSelf(reason, force) {
  if (typeof document === 'undefined' || !document.hidden) return false;
  if (!force && isCasting()) {
    console.log('[BringToFront] Google Cast castet - die Ziel-App bleibt vorn (' + reason + ')');
    return false;
  }
  const app = window.tizen && window.tizen.application;
  const id = ownAppId();
  if (!app || typeof app.launch !== 'function' || !id) return false;
  console.log('[BringToFront] tv-app ist verdeckt - hole sie nach vorn (' + reason + ')');
  try {
    app.launch(
      id,
      () => console.log('[BringToFront] launch ok'),
      (e) => console.log('[BringToFront] launch abgelehnt:', (e && (e.message || e.name)) || e)
    );
    return true;
  } catch (e) {
    console.log('[BringToFront] launch nicht moeglich:', (e && (e.message || e.name)) || e);
    return false;
  }
}

const BringToFront = {
  // Aus den Power-Listenern beim Wechsel auf "an" (remotepower NORMAL bzw.
  // b2bpower Normal). Ein erneuter Aufruf ersetzt die geplanten Pruefungen.
  onPowerOn(reason) {
    if (typeof window === 'undefined' || !window.tizen) return;
    timers.forEach((t) => clearTimeout(t));
    timers = CHECK_DELAYS_MS.map((ms) => setTimeout(() => launchSelf(reason + ', +' + ms + ' ms'), ms));
  },
  // Beim Standby geplante Pruefungen verwerfen - siehe oben, warum im
  // Standby nichts nach vorn geholt werden darf.
  cancel() {
    timers.forEach((t) => clearTimeout(t));
    timers = [];
  },
  // Die EINE Ausnahme vom "nie im Standby": unmittelbar vor dem
  // Cast-Standby-Neustart (cast/scheduleStandbyReboot, Schalter
  // CAST_REBOOT_FRONT).
  //
  // Anlass: am U800F faehrt der TV nach dem Neustart im Standby hoch, OHNE
  // die tizenStartapp zu starten, und beim Einschalten holt die Firmware die
  // zuletzt benutzte App (YouTube des Casts) - der TV war bis zum ersten HOME
  // weder fuer den Gast noch fuer den SocketAdmin da. Ist die tv-app vor dem
  // Neustart vorn, ist SIE die zuletzt benutzte App.
  //
  // Die Bedenken von oben gelten hier nicht: die Pruefung "App im
  // Vordergrund" des Neustart-Timers ist schon gelaufen, und rebootImminent
  // sorgt dafuer, dass das kurze Sichtbarwerden nicht als Aufwachen zaehlt
  // (kein POWER_STATE=ON, kein Aufraeumen - siehe keyHandler/Tizen.js).
  //
  // Offen und der Grund fuer den Schalter: ob launch im Standby den
  // Bildschirm einschaltet. Das zeigt der Test auf Staging.
  forReboot(reason) {
    const major = tizenMajor();
    if (major < REBOOT_FRONT_MIN_TIZEN) {
      console.log(
        '[BringToFront] vor dem Neustart nichts nach vorn geholt - Tizen ' +
          (major || '?') + ' (erst ab ' + REBOOT_FRONT_MIN_TIZEN + ', siehe REBOOT_FRONT_MIN_TIZEN)'
      );
      return false;
    }
    rebootImminent = true;
    BringToFront.cancel();
    return launchSelf(reason, true);
  },
  isRebootImminent() {
    return rebootImminent;
  },
  _launchSelf: launchSelf,
};

export default BringToFront;



// WEBPACK FOOTER //
// ./src/helpers/BringToFront.js